import React from 'react';
import { motion } from 'motion/react';
import { useTranslations } from 'use-intl';
import styled from 'styled-components';

function Question({
  addingQuestion,
  editingQuestion,
  isCancelling,
  isHidden,
  newQuestionOrder,
  question,
  setEditorIsFocused,
  children
}) {
  const t = useTranslations('Review');
  const isEditMode = addingQuestion || editingQuestion;

  // Calculate animation props directly
  const initial = addingQuestion ? { opacity: 0, scale: 0.95 } : undefined;

  const animate = addingQuestion
    ? { opacity: 1, scale: 1, transition: { delay: 0.2 } }
    : { opacity: 1, scale: 1 };

  const exit =
    addingQuestion && isCancelling
      ? { opacity: 0, scale: 0.95, transition: { duration: 0.3 } }
      : addingQuestion
        ? { opacity: 1, scale: 1, transition: { duration: 0 } }
        : undefined;

  return (
    <Container
      key={addingQuestion ? 'add-question' : question.id}
      addingQuestion={addingQuestion}
      editingQuestion={editingQuestion}
      isEditMode={isEditMode}
      isCancelling={isCancelling}
      isHidden={isHidden}
      initial={initial}
      animate={animate}
      exit={exit}
      onFocus={() => isEditMode && setEditorIsFocused(true)}
      onBlur={() => isEditMode && setEditorIsFocused(false)}
      newQuestionOrder={newQuestionOrder}
      questionOrder={question?.order}>
      <h4>
        {t('questionNumber', {
          number: addingQuestion ? newQuestionOrder : question.order
        })}
      </h4>
      {children}
    </Container>
  );
}

const Container = styled(motion.div)`
  background: #fff;
  border: ${({ isEditMode }) =>
    isEditMode
      ? '0.063rem solid var(--dark-blue)'
      : '0.063rem solid var(--light-grey)'};
  border-radius: var(--border-radius-sm);
  left: ${({ addingQuestion, isCancelling }) =>
    addingQuestion && isCancelling ? '0.563rem' : 'auto'};
  margin-bottom: ${({ addingQuestion }) => (addingQuestion ? '1.25rem' : '0')};
  padding: ${({ isEditMode }) =>
    isEditMode ? 0 : '1.25rem 1.188rem 1.188rem'};
  position: ${({ addingQuestion, isCancelling }) =>
    addingQuestion && isCancelling ? 'absolute' : 'relative'};
  right: ${({ addingQuestion, isCancelling }) =>
    addingQuestion && isCancelling ? '0.563rem' : 'auto'};
  width: ${({ addingQuestion, isCancelling }) =>
    addingQuestion && !isCancelling ? '100%' : 'auto'};

  h4 {
    margin-bottom: 1.15em;
    opacity: ${({ isHidden }) => (isHidden ? 0.5 : 1)};
    position: ${({ isEditMode }) => (isEditMode ? 'absolute' : 'relative')};
    top: ${({ isEditMode }) => (isEditMode ? '1.3125rem' : 0)};
    left: ${({ isEditMode }) => (isEditMode ? '1.25rem' : 0)};
    z-index: ${({ isEditMode }) => (isEditMode ? 1 : 0)};
  }

  .markup {
    color: var(--dark-blue);
    font-family: 'Inter', sans-serif;
    font-size: 1.25rem;
    line-height: 120%;
    margin-bottom: 1.3em;
    opacity: ${({ isHidden }) => (isHidden ? 0.5 : 1)};

    img {
      display: block;
      height: auto;
      max-width: 100%;
    }
  }

  button {
    font-weight: 500;
  }
`;

export default Question;
